/** cSpell:words Cobranded */
import { Link, Outlet } from 'react-router-dom';
import brandLogo from './assets/icons/clientLogo.svg';

const Layout = () => {
  const { VITE_CLIENT_FRIENDLY_NAME } = import.meta.env;
  const styles = {
    logo: 'w-13.5',
  };

  return (
    <>
      <div className="min-h-screen">
        <header className="mx-auto w-11/12 md:w-9/12 py-1!">
          <div className="flex p-4 content-between justify-between">
            <Link to="/" className="self-center">
              <span className="sr-only">{VITE_CLIENT_FRIENDLY_NAME}</span>
              <img src={brandLogo} alt={VITE_CLIENT_FRIENDLY_NAME} className={styles.logo} />
            </Link>
          </div>
        </header>
        <main>
          <Outlet />
        </main>
        <footer>
          <div className="mx-auto w-11/12 md:w-9/12 py-4 text-center text-sm text-gray-500">
            &copy; {new Date().getFullYear()} {VITE_CLIENT_FRIENDLY_NAME}. All rights reserved.
          </div>
        </footer>
      </div>
    </>
  );
};
export default Layout;
